var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Word"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.4375 2.01562H12.5225C13.1656 2.01575 13.7784 2.26965 14.2324 2.72363L18.9014 7.38867C19.3554 7.84275 19.6094 8.46016 19.6094 9.10352V19.0625C19.6094 20.3983 18.5233 21.4844 17.1875 21.4844H7.4375C6.1017 21.4844 5.01562 20.3983 5.01562 19.0625V4.4375C5.01562 3.1017 6.1017 2.01562 7.4375 2.01562ZM7.4375 3.8125C7.09371 3.8125 6.8125 4.09371 6.8125 4.4375V19.0625C6.8125 19.4063 7.09371 19.6875 7.4375 19.6875H17.1875C17.5313 19.6875 17.8125 19.4063 17.8125 19.0625V9.90625H14.4453C12.9381 9.90625 11.7188 8.68688 11.7188 7.17969V3.8125H7.4375ZM14.4795 12.4473C14.5993 11.9644 15.0864 11.6722 15.5693 11.792C16.0519 11.912 16.3432 12.3981 16.2236 12.8809L15.0049 17.7559C14.9113 18.1375 14.5787 18.4111 14.1855 18.4336C13.7926 18.456 13.4335 18.2203 13.2949 17.8535L12.3232 15.2598L12.3086 15.2207L12.2939 15.2598L11.3232 17.8535C11.1847 18.2204 10.8247 18.4561 10.4316 18.4336C10.0386 18.411 9.70583 18.1375 9.6123 17.7559L8.39355 12.8809C8.27393 12.4018 8.56603 11.9118 9.04883 11.792C9.5317 11.6724 10.0179 11.9645 10.1377 12.4473L10.6445 14.4727L10.6562 14.5215L10.6738 14.4746L11.4697 12.3496C11.6007 11.9978 11.9381 11.7656 12.3125 11.7656C12.6402 11.7656 12.9386 11.9436 13.0908 12.2236L13.1475 12.3496L13.9434 14.4746L13.9609 14.5215L13.9727 14.4727L14.4795 12.4473ZM13.5156 7.17969C13.5156 7.69486 13.9301 8.10938 14.4453 8.10938H17.0771L17.0498 8.08301L13.542 4.5752L13.5156 4.54785V7.17969Z",
    fill: "#0D70DC",
    stroke: "#0D70DC",
    strokeWidth: 0.03125
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.37bf5f33cd4e708713c67859652fac76.svg";
export { ForwardRef as ReactComponent };